
/* be carefull other declaration  in backend */
export const lengthOfToken = 65;
export const nbMaxToken = 10;
export const lengthOfInput = 650;
export const lengthOfLink = 44;

export const trainingTypes = {
  withForm: 'withForm',
  withQuestion: 'withQuestion',
  withWebAnswer: 'withWebAnswer',
};

export const contentWithFormString =
  process.env.REACT_APP_NODE_ENV === 'development'
    ? 'triton.anemon.fr/g/'
    : 'triton.anemon.fr/g/';

export const dynamicUrlPattern =
  process.env.REACT_APP_NODE_ENV === 'development'
    ? /Lien pour répondre: (https?:\/\/)?51\.75\.185\.48\/m\?q\/[^\s\n]+/
    : /Lien pour répondre: triton\.anemon\.fr\/[m]?[q]\/[^\s\n]+/;

export const trainingResponseType = {
  // Closed response
  none: 'none',
  open: 'open',
  closedCorrect: 'closedCorrect',
  closedIncorrect: 'closedIncorrect',

  // Web answer
  webDescription: 'webDescription',
  webCorrectReponse: 'webCorrectReponse',
  webIncorrectResponse: 'webIncorrectResponse',
  webInfoResponse: 'webInfoResponse',
};

export const trainingWebAnswerTypes = {
  TEXT: {
    value: 'Short Answer',
    label: 'Réponse courte',
  },
  MULTIPLE_CHOICE: {
    value: 'Multiple choice',
    label: 'Choix multiple',
  },
  CHECKBOX: {
    value: 'Checkboxes',
    label: 'Case à cocher',
  },
};

export const TRAINING_STATUSES = {
  on_hold: {
    value: 'on_hold',
    label: 'En attente',
  },
  pending: {
    value: 'pending',
    label: 'En cours',
  },
  responded: {
    value: 'responded',
    label: 'Répondu',
  },
  rejected: {
    value: 'rejected',
    label: 'Rejeté',
  },
  completed: {
    value: 'completed',
    label: 'Envoyé',
  },
  deactivated: {
    value: 'deactivated',
    label: 'Désactivé',
  },
  deleted: {
    value: 'deleted',
    label: 'Supprimé',
  }
};
